<template>
  <v-dialog
    :value="show"
    max-width="600"
    @click:outside="$emit('update:show', false)"
  >
    <v-card :loading="loading" :disabled="loading">
      <v-card-title>
        Update Server
      </v-card-title>
      <v-card-text>
        <validation-observer ref="validationObserver" slim>
          <server-form
						v-if="server"
            ref="form"
            v-model="server"
            :params="params"
            @submit="updateServer"
          >
          </server-form>
          <v-btn color="primary" block @click="onStreamStart" class="mb-2">
            Start server
          </v-btn>
          <v-btn color="danger" block @click="onStreamStop" class="mb-2">
            Stop server
          </v-btn>
          <v-btn color="warning" block @click="onStreamRestart" class="mb-2">
            Restart stream
          </v-btn>
        </validation-observer>
        <v-card-actions>
          <v-btn color="primary" @click="$emit('update:show', false)">
            Back
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn type="button" color="success" @click="updateServer">
            Update
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ServerCreateUpdate from "./ServerCreateUpdate.js";
import {
  updateServer,
  fetchServer,
  restartStream,
  stopStream,
  startStream
} from "../../../../api/server.api.js";

export default {
  name: "ServerUpdateDialog",
  extends: ServerCreateUpdate,
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: false,
      default: null
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.fetchParams();
        this.fetchServer();
      } else {
        this.server = {
          domain: "",
          pageStyle: null,
          timeZone: null
        };
      }
    }
  },
  methods: {
    async onStreamStart() {
      try {
        await startStream(this.id);
      } catch (e) {
        console.error(e);
      }
    },
    async onStreamStop() {
      try {
        await stopStream(this.id);
      } catch (e) {
        console.error(e);
      }
    },
    async onStreamRestart() {
      try {
        await restartStream(this.id);
      } catch (e) {
        console.error(e);
      }
    },
    async fetchServer() {
      const response = await fetchServer(this.id);

      this.server = response.data.server;
    },
    async updateServer() {
      const valid = await this.$refs.validationObserver.validate();

      if (valid) {
        const { server } = this;

        updateServer(this.id, server)
          .then(() => {
            this.$emit("update:show", false);
            this.$emit("update");
          })
          .catch(error =>
            this.handleErrorResponse(this.$refs.validationObserver, error)
          );
      }
    }
  }
};
</script>

<style scoped></style>
